import React from 'react';
import { observer } from 'mobx-react-lite';
import { liveUpdateStore } from '../../../store/liveUpdateStore';
import { userInfoStore } from '../../../store/userInfoStore';
import useTranslation from '../../../hooks/useTranslation';
import { allGameTableColumns } from '../../../core/constants/allGameTableColumns';
import Table from '../../../components/table';

const AllGamesLiveBets = observer(() => {
  const { allGamesLiveSpins } = liveUpdateStore;
  const { rate, precision, userId, currencyCode } = userInfoStore;
  const t = useTranslation();
  return (
    <Table
      t={t}
      rate={rate}
      currentUserId={userId}
      currency={currencyCode}
      precision={precision}
      columns={allGameTableColumns}
      data={allGamesLiveSpins}
    />
  );
});

export default AllGamesLiveBets;
